export default __webpack_public_path__ + "static/media/header-youtube.8bf97a7e.png";